import React from "react";
import { motion } from "framer-motion";
import { SilhouetteVehicle } from "./SilhouetteVehicle";

/**
 * DeliveryCard — carte agenda "À venir".
 * Heure XXL Inter Display à gauche, séparateur, miniature véhicule, client & adresse.
 */
export function DeliveryCard({
  time,
  vehicle,
  client,
  address,
  image,
  silhouette = "berline",
  isToday = false,
  isNext = false,
  index = 0,
  testid,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -8 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{
        delay: 0.06 * index + 0.15,
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1],
      }}
      data-testid={testid}
      className="group relative flex items-center gap-6 rounded-[16px] p-4 transition-colors duration-200 hover:bg-white"
    >
      {/* Heure XXL */}
      <div className="flex flex-col items-start w-[130px] flex-shrink-0">
        <span
          className="wyvio-tabular font-medium leading-none tracking-[-0.035em] text-[#151515]"
          style={{ fontSize: "48px" }}
        >
          {time}
        </span>
        <span className="mt-2 text-[10.5px] font-medium uppercase tracking-[0.18em] text-[#6B6B67]">
          {isToday ? "Aujourd'hui" : isNext ? "Prochaine" : "À venir"}
        </span>
      </div>

      {/* Séparateur vertical fin */}
      <div className="h-14 w-px bg-[#E8E8E2]" aria-hidden />

      {/* Miniature véhicule */}
      <div className="h-[60px] w-[100px] flex-shrink-0 overflow-hidden rounded-[10px]">
        {image ? (
          <img
            src={image}
            alt={vehicle}
            className="h-full w-full object-cover"
          />
        ) : (
          <SilhouetteVehicle type={silhouette} className="h-full w-full" />
        )}
      </div>

      {/* Infos */}
      <div className="min-w-0 flex-1">
        <p className="truncate text-[15px] font-medium tracking-[-0.01em] text-[#151515]">
          {vehicle}
        </p>
        <p className="mt-1 truncate text-[12.5px] text-[#6B6B67]">
          {client} · {address}
        </p>
      </div>

      {/* Indicateur "prochaine" */}
      {isNext && (
        <span
          aria-hidden
          className="wyvio-segment-active h-2 w-2 rounded-full"
          style={{ background: "#C8FF2F" }}
        />
      )}
    </motion.div>
  );
}
